import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=7a29f8cc&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a29f8cc')) {
      api.createRecord('7a29f8cc', component.options)
    } else {
      api.reload('7a29f8cc', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=7a29f8cc&", function () {
      api.rerender('7a29f8cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26GQ6lqh8qp9c/JS/comp/ImgFallback2.vue"
export default component.exports